import { cloneWithoutReactivity } from "@nextories/vue-core-components/src/store/common";
import filterHelper from "@nextories/vue-tasks/src/utils/helpers/common/filter";
import tasksHelper from "@nextories/vue-tasks/src/utils/helpers/tasks";
import { i18n } from "@/plugins/i18n";
import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore";

export const pluginTasksStore = {
  state: {
    listStatusAvailable: ['Planned', 'Not Held'],
    displayFormNewTask: false,
  },
  actions: {
    setInitialFilters(query: {}) {
      const { listTasksType } = this;
      const filterUsers = useUsersStore().$state.filterUsers;
      // Modify the title of myTasks if exists
      if (filterUsers && filterUsers.myTasks) {
        filterUsers.myTasks.title = i18n.global.t("base.myProjectsTasks");
      }
      // Set subFilters directly, no need for deep cloning unless required
      this.subFilters = {
        ...cloneWithoutReactivity(filterUsers),
        ...cloneWithoutReactivity(listTasksType),
        ...tasksHelper.statusDgtFilter(i18n.global.tm("project.shortStatus")),
        ...tasksHelper.urgentFilter(),
      };
      // Set the base main filters
      this.setBaseMainFilters(query);
      const mainFilters = this.baseMainFilters;
      // Remove unnecessary filters
      delete mainFilters.notAssignedUser;
      delete mainFilters.clientRequest;
      // Update 'today' filter with the new subFilters
      mainFilters.today = {
        ...mainFilters.today,
        subFilters: {
          ...this.subFilters,
          ...filterHelper.setSubFilterEnabled('today', filterUsers.myTasks, query),
        },
      };
      // Update 'allTasks' filter with the new subFilters and other query params
      mainFilters.allTasks = {
        ...mainFilters.allTasks,
        query: {
          status: this.listStatusAvailable,
        },
        subFilters: {
          ...this.subFilters,
          ...filterHelper.formatDatesFilter("dateDue", "date_due"),
          ...cloneWithoutReactivity(tasksHelper.directionFilter()),
        },
      };
      // Set the final main filters, no need for deep cloning unless required
      this.setMainFilters(
        cloneWithoutReactivity(filterHelper.setOrderMainFilters(mainFilters)),
      );
    },
  },
};
